export default {
  action_required: 'Action Required',
  load_more: 'Load More',
  mark_all_as_read: 'Mark All As Read',
  notification: 'Notification',
  notifications: 'Notifications',
  today: 'Today',
  updates: 'Updates'
};